<template>
    <div ref="root">
        <div class="video__container module__container">
            <div class="video__inner module__inner">
                <div class="video__inner--main module__inner--main">
                    <div class="video__inner--video">
                        <div class="video__inner-row module__inner-row">
                            <div class="video__inner-col module__inner-col">
                                <div
                                    class="video__optin bg-color-gradient"
                                    v-if="!this.editorMode"
                                    v-bind:data-provider="videoType"
                                >
                                    <div
                                        v-bind:style="
                                            'background-image: url(\'' +
                                                generateMediaUrl({
                                                    path: 'media/images/video/placeholder.jpg'
                                                }) +
                                                '\')'
                                        "
                                        class="video__optin-bg"
                                    ></div>
                                    <p class="video__optin-text color-p">
                                        <span class="video__optin-toggler-wrap">
                                            <input
                                                type="checkbox"
                                                :id="'video__optin-toggler' + module.id"
                                                class="video__optin-toggler"
                                                name="video__optin-toggler"
                                            />
                                            <label
                                                class="video__optin-toggler-label"
                                                :for="'video__optin-toggler' + module.id"
                                                v-html="videoOptInOutText"
                                            ></label>
                                        </span>
                                    </p>
                                </div>
                                <div
                                    class="video__embed-container"
                                    :data-source="module.data.source"
                                    :data-loop="module.data.loop"
                                ></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="video__inner--content"
                        v-if="
                            [1, 2, 3, 4].includes(module.layout.type) &&
                                (module.data.title || module.data.subtitle || module.data.text)
                        "
                        v-bind:class="{
                            container__boxed: [3, 4].includes(module.layout.type)
                        }"
                    >
                        <div class="video__inner-row module__inner-row">
                            <div class="video__inner-col module__inner-col">
                                <h2
                                    class="video__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="video__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                        <div class="video__inner-row module__inner-row" v-if="module.data.text">
                            <div class="video__inner-col module__inner-col">
                                <div
                                    class="video__text module__text font-p color-p module__cms"
                                    v-if="module.data.text"
                                    v-html="module.data.text"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="video__optout border-color-highlighted"
                    v-if="!this.editorMode"
                    v-bind:data-provider="videoType"
                >
                    <span class="video__optout-toggler-wrap">
                        <input
                            type="checkbox"
                            :id="'video__optout-toggler' + module.id"
                            class="video__optout-toggler"
                            name="video__optout-toggler"
                        />
                        <label
                            class="video__optout-toggler-label font-small"
                            :for="'video__optout-toggler' + module.id"
                            v-html="videoOptInOutText"
                        ></label>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VideoPlayer from '@/external/assorted/VideoPlayer';

export default {
    data() {
        return {
            defaultId: '330706510'
        };
    },
    components: {},
    methods: {},
    computed: {
        ...mapGetters(['editorMode', 'generateMediaUrl']),
        videoType() {
            let source = this.module.data.source;
            if (source.indexOf('youtu') > 0 || (isNaN(source) && source.length === 11)) {
                return 'youtube';
            } else {
                return 'vimeo';
            }
        },
        videoOptInOutText() {
            return this.videoType === 'youtube'
                ? this.$helpers.uiText('F002')
                : this.$helpers.uiText('F003');
        }
    },
    props: {
        module: Object
    },
    mounted() {
        if (this.editorMode) {
            let i = new VideoPlayer();
            i.init(this.$refs.root);
        }
    },
    updated() {
        if (this.editorMode) {
            let i = new VideoPlayer();
            i.init(this.$refs.root);
        }
    }
};
</script>
